<template>
  <section class="pointer-events-none touch-none lg:hidden sticky top-1/2 -translate-y-1/4 w-full h-[30vh] overflow-hidden no-scrollbar">
    <div class="pointer-events-none touch-none absolute top-0 left-0 w-full h-full z-2 flex items-center justify-center">
      <div class="whitespace-pre-line font-semibold uppercase text-center text-5xl md:text-[4.167vw] big-screen:text-[6vw] leading-[1]">
        <h1 class="animate-title">{{ "Featured Works" }}</h1>
      </div>
    </div>
  </section>
  <section class="pointer-events-none touch-none lg:hidden sticky top-1/2 -translate-y-1/4 w-full h-[30vh] overflow-hidden no-scrollbar">
    <div class="absolute top-0 left-0 w-full h-full z-2 flex items-center justify-center uppercase rounded-full rotate-6">
      <div class="relative text-base w-fit px-4 py-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-yellow -scale-x-[1.6] scale-y-[1.3]" viewBox="0 0 206 62" fill="none">
        <g clip-path="url(#clip0_3430_9566)">
        <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
        </g>
        <defs>
        <clipPath id="clip0_3430_9566">
        <rect width="206" height="62" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        <div class="relative z-1">Motion Graphic</div>
      </div>
    </div>
  </section>
  <section class="pointer-events-none touch-none lg:hidden sticky top-1/2 -translate-y-1/4 w-full h-[30vh] overflow-hidden no-scrollbar">
    <div class="absolute top-0 left-0 w-full h-full z-2 flex items-center justify-center uppercase rounded-full -rotate-12">
      <div class="relative text-base w-fit px-4 py-2 text-white">
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-blue -scale-x-[1.6] -scale-y-[1.3]" viewBox="0 0 206 62" fill="none">
        <g clip-path="url(#clip0_3430_9566)">
        <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
        </g>
        <defs>
        <clipPath id="clip0_3430_9566">
        <rect width="206" height="62" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        <div class="relative z-1">3D Animation</div>
      </div>
    </div>
  </section>
  <section class="pointer-events-none touch-none lg:hidden sticky top-1/2 -translate-y-1/4 w-full h-[30vh] overflow-hidden no-scrollbar">
    <div class="absolute top-0 left-0 w-full h-full z-2 flex items-center justify-center uppercase rounded-full -rotate-2">
      <div class="relative text-white text-base w-fit px-4 py-2">
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-purple -scale-x-[1.6] -scale-y-[1.3]" viewBox="0 0 206 62" fill="none">
        <g clip-path="url(#clip0_3430_9566)">
        <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
        </g>
        <defs>
        <clipPath id="clip0_3430_9566">
        <rect width="206" height="62" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        <div class="relative z-1">3D Anamorphic</div>
      </div>
    </div>
  </section>

  <section class="pointer-events-none touch-none lg:hidden sticky top-1/2 -translate-y-1/4 w-full h-[30vh] overflow-hidden no-scrollbar">
    <div class="absolute top-0 left-0 w-full h-full z-2 flex items-center justify-center uppercase rounded-full rotate-2">
      <div class="relative text-base w-fit px-4 py-2 text-white">
        <svg xmlns="http://www.w3.org/2000/svg" class="absolute top-0 left-0 w-full h-full text-ellie-orange -scale-x-[1.6] -scale-y-[1.3]" viewBox="0 0 206 62" fill="none">
        <g clip-path="url(#clip0_3430_9566)">
        <path d="M205.506 -2.7158L22.2321 -2.65976L-1.36607 20.9119L-0.701011 63.5242L183.74 61.5609L206.595 39.6317L205.506 -2.7158Z" fill="currentColor"/>
        </g>
        <defs>
        <clipPath id="clip0_3430_9566">
        <rect width="206" height="62" fill="white"/>
        </clipPath>
        </defs>
        </svg>
        <div class="relative z-1">Explainer Video</div>
      </div>
    </div>
  </section>
</template>
